import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-filter",
  "use": "icon-filter-usage",
  "content": "<symbol id=\"icon-filter\"><path d=\"M6.5 5h11a.5.5 0 0 1 .5.5v1.148a1 1 0 0 1-.22.626l-3.57 4.452a1 1 0 0 0-.22.626v3.78a1 1 0 0 1-.4.8l-3.095 2.321a.3.3 0 0 1-.48-.24v-6.661a1 1 0 0 0-.22-.626L6.22 7.274A1 1 0 0 1 6 6.648V5.5a.5.5 0 0 1 .5-.5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol